import { useGlobalStore } from '@/stores/globalStore';

const checkGeo = (countryCode) => {
  const globalStore = useGlobalStore();
  const isGeoMatching = globalStore.global.detectedGeo?.country_code === countryCode;
  return isGeoMatching;
};

const getCountryAndRegion = () => {
  const globalStore = useGlobalStore();
  const country = globalStore.global.detectedGeo?.country_code;
  const region = globalStore.global.detectedGeo?.region;
  return { country, region };
};

/** Tracking-safe geo snapshot (no IP). Returns null when geo has not loaded yet. */
const getDetectedGeoForTracking = () => {
  const geo = useGlobalStore().global.detectedGeo;
  if (!geo) return null;

  return {
    country: geo.country_code ?? null,
    region: geo.region ?? null,
    city: geo.city ?? null,
  };
};

export { checkGeo, getCountryAndRegion, getDetectedGeoForTracking };
export default checkGeo;
